import React from 'react';
import { Icon } from '../Icon/Icon.jsx';
import { BODY } from '../../primitives.js';

const h = React.createElement;

/**
 * @param {object} p
 * @param {{ label: React.ReactNode; href?: string; onClick?: React.MouseEventHandler }[]} p.items
 */
export function Breadcrumbs({ items = [] }) {
  return h('nav', { 'aria-label': 'Breadcrumb' }, h('ol', { style: { display: 'flex', alignItems: 'center', gap: 4, flexWrap: 'wrap', listStyle: 'none', margin: 0, padding: 0, fontFamily: BODY, fontSize: 12.5, fontWeight: 600 } },
    items.map((it, i) => { const last = i === items.length - 1; return h('li', { key: i, style: { display: 'inline-flex', alignItems: 'center', gap: 4 } },
      last ? h('span', { 'aria-current': 'page', style: { color: 'var(--tx)', fontWeight: 800 } }, it.label)
        : h('a', { href: it.href || '#', onClick: it.onClick, className: 'hv-link', style: { color: 'var(--mut)', textDecoration: 'none' } }, it.label),
      last ? null : h(Icon, { name: 'chevron-right', size: 14, style: { color: 'var(--mut3)' } })); })));
}
